export default "__VITE_ASSET__CiUV0gTB__"